const SENTENCE_REGEX = /[^\.!\?]+[\.!\?]+["']?|.+$/g

export default function capitalizeText(text: string) {
	const sentences = text.match(SENTENCE_REGEX)
	return (sentences as any)
		.map((text: any) => {
			const trimmed = text.trimStart()
			return trimmed.slice(0, 1).toUpperCase() + trimmed.slice(1)
		})
		.join('')
}
